import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileConflictDeclarationsEditorActions'

import { validiateChecklistField } from '../../../common/forms/validationFunctions'

const initialState = {
  submitting: false,
  loadingDeclarations: false,
  editingDeclarations: false,
  conflictDeclarationsBeforeEditing: [],
  allDeclarations: [],
  isInvalid: {
    formIsValid: true,
    conflictDeclarations: {
      isInvalid: false,
      message: null
    }
  }
}

const minimumRequiredSelection = 0

export default function (state = initialState, action) {
  var newState = copyConflictDeclarationsState(state)

  const { edit, fetch, set } = events
  switch (action.type) {
    case edit.start:
      newState.conflictDeclarations.editingDeclarations = true
      newState.conflictDeclarationsBeforeEditing = newState.profile.conflictDeclarations
      newState.independenceBeforeEditing = newState.profile.isIndependent
      newState.conflictDeclarations.isInvalid.conflictDeclarations = validiateChecklistField(newState.profile.conflictDeclarations, minimumRequiredSelection)
      newState.conflictDeclarations.isInvalid.formIsValid = formIsValid(newState.conflictDeclarations.isInvalid)
      return newState
    case edit.stop:
      newState.conflictDeclarations.editingDeclarations = false
      return newState
    case edit.cancel:
      newState.conflictDeclarations.editingDeclarations = false
      newState.profile.conflictDeclarations = cloneDeep(newState.conflictDeclarationsBeforeEditing)
      newState.profile.isIndependent = cloneDeep(newState.independenceBeforeEditing)
      newState.conflictDeclarationsBeforeEditing = []
      return newState
    case fetch.fetched:
      newState.conflictDeclarations.allDeclarations = action.payload
      return newState
    case set.selectionChanged:
      var foundIndex = null
      var selectedDeclarations = newState.profile.conflictDeclarations
      var allDeclarations = newState.conflictDeclarations.allDeclarations
      selectedDeclarations.forEach((conflictDeclaration, index) => {
        if (conflictDeclaration.conflictDeclarationId === action.conflictDeclaration.conflictDeclarationId) {
          foundIndex = index
        }
      })
      if (foundIndex !== null) {
        selectedDeclarations.splice(foundIndex, 1)
      } else {
        selectedDeclarations.push(action.conflictDeclaration)
      }
      newState.profile.isIndependent = validateAllChecklistChecked(selectedDeclarations, allDeclarations, 'conflictDeclarationId')
      newState.conflictDeclarations.isInvalid.conflictDeclarations = validiateChecklistField(selectedDeclarations, minimumRequiredSelection)
      newState.conflictDeclarations.isInvalid.formIsValid = formIsValid(newState.conflictDeclarations.isInvalid)
      newState.edited = true
      return newState
    case set.isIndependent:
      newState.profile.conflictDeclarations = []
      var isIndependentSelectedDeclarations = newState.profile.conflictDeclarations
      newState.profile.isIndependent = validateAllChecklistChecked(isIndependentSelectedDeclarations, newState.conflictDeclarations.allDeclarations, 'conflictDeclarationId')
      newState.conflictDeclarations.isInvalid.conflictDeclarations = validiateChecklistField(isIndependentSelectedDeclarations, minimumRequiredSelection)
      newState.conflictDeclarations.isInvalid.formIsValid = formIsValid(newState.conflictDeclarations.isInvalid)
      newState.edited = true
      return newState
  }
  return state
}

function copyConflictDeclarationsState (state) {
  var newState = cloneDeep(state)
  newState.profile = cloneDeep(state.profile)
  if (state.profile) {
    newState.profile.conflictDeclarations = cloneDeep(state.profile.conflictDeclarations)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.conflictDeclarations.isInvalid
}

export function validateAllChecklistChecked (selectedList, availableList, key) {
  let allChecked = true
  availableList.forEach(availableItem => {
    let wasFound = false
    selectedList.forEach(selectedItem => {
      if (selectedItem[key] === availableItem[key]) wasFound = wasFound || true
    })
    allChecked = allChecked && wasFound
  })
  return allChecked
}
